import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "sonner";
import "@/App.css";

import EmBreve from "@/pages/EmBreve";
import ProductList from "@/pages/ProductList";
import ProductDetail from "@/pages/ProductDetail";
import ListaOrcamento from "@/pages/ListaOrcamento";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminBrands from "@/pages/admin/AdminBrands";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminScrapers from "@/pages/admin/AdminScrapers";
import AdminScrapersCuradoria from "@/pages/admin/AdminScrapersCuradoria";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminBanners from "@/pages/admin/AdminBanners";

const Protected = ({ children }) => {
    const { user, ready } = useAuth();
    if (!ready) return <div className="min-h-screen grid place-items-center font-mono text-sm text-neutral-500">carregando…</div>;
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
};

function App() {
    return (
        <AuthProvider>
            <CartProvider>
            <BrowserRouter>
                <Toaster richColors position="bottom-right" duration={2500} />
                <Routes>
                    <Route path="/" element={<EmBreve />} />
                    <Route path="/produtos" element={<ProductList />} />
                    <Route path="/produtos/:id" element={<ProductDetail />} />
                    <Route path="/lista" element={<ListaOrcamento />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
                        <Route index element={<AdminDashboard />} />
                        <Route path="produtos" element={<AdminProducts />} />
                        <Route path="marcas" element={<AdminBrands />} />
                        <Route path="categorias" element={<AdminCategories />} />
                        <Route path="banners" element={<AdminBanners />} />
                        <Route path="leads" element={<AdminLeads />} />
                        <Route path="orcamentos" element={<AdminQuotes />} />
                        <Route path="scrapers" element={<AdminScrapers />} />
                        <Route path="scrapers/curadoria" element={<AdminScrapersCuradoria />} />
                        <Route path="configuracoes" element={<AdminSettings />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            </CartProvider>
        </AuthProvider>
    );
}

export default App;
